//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import couponList from '../index.vue';
export default {
  name: 'CouponFrom',
  components: {
    couponList: couponList
  },
  data: function data() {
    return {
      visible: false,
      callback: function callback() {},
      handle: '',
      keyNum: 0,
      coupons: [],
      userIds: '',
      userType: ''
    };
  },
  watch: {
    // show() {
    //   this.visible = this.show
    // }
  },
  methods: {
    handleClose: function handleClose() {
      this.visible = false;
    },
    getCouponId: function getCouponId(couponObj) {
      this.callback(couponObj);
      this.visible = false;
    },
    dialogclose: function dialogclose() {
      this.visible = false;
    }
  }
};